export default __webpack_public_path__ + "static/media/pot_5_trunk_5_mat_1_leaves_4_flowers_5_color_4_prop_5 1.ab9254e8.png";